import { Container, Typography } from "@mui/material";

import useStyles from "./styles";

const SupplierSelfAssessmentSuccess = () => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <>
        <div className={classes.topHeading}>
          <Typography
            variant="h4"
            component="h4"
            className={classes.mainHeading}
          >
            Thank You for Completing the FREE ESG Self-Assessment!
          </Typography>
          <Typography variant="h5" component="h4" marginTop={10}>
            Your response have been successfully submitted.
          </Typography>
          <Typography variant="h5" component="h4">
            A summary of your ESG assessment score will be emailed to you
            shortly.
          </Typography>
        </div>
      </>
    </Container>
  );
};

export default SupplierSelfAssessmentSuccess;
